export default __webpack_public_path__ + "static/media/ie.ced2e78a.svg";